import React from 'react';
import { useI18n } from '../i18n';
import { Star } from 'lucide-react';

const COLORS = ['#e8c26a', '#3b74ff', '#3fb950', '#d7263d', '#9b6bff', '#2fbfae'];

export default function Testimonials() {
  const { t } = useI18n();
  return (
    <section id="avis" style={{ padding: '44px 24px' }}>
      <div style={{ maxWidth: 1160, margin: '0 auto' }}>
        <p style={{ textAlign: 'center', fontSize: 13, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--hm-gold)', margin: 0 }}>{t.reviews.eyebrow}</p>
        <h2 className="font-sora" style={{ textAlign: 'center', margin: '10px 0 0', fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 800, letterSpacing: '-0.02em' }}>{t.reviews.title}</h2>
        <p style={{ textAlign: 'center', margin: '12px auto 0', maxWidth: '52ch', fontSize: 16, color: 'var(--color-neutral-400)', lineHeight: 1.6 }}>{t.reviews.subtitle}</p>
        <div style={{ marginTop: 44, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20 }}>
          {t.reviews.items.map((it, idx) => (
            <div key={idx} className="card-surface" style={{ padding: '24px 22px', display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={{ display: 'flex', gap: 2 }}>{[0,1,2,3,4].map((i) => (<Star key={i} size={15} fill="#e8c26a" color="#e8c26a" />))}</div>
              <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: 'var(--color-text)' }}>“{it.text}”</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 'auto' }}>
                <span style={{ width: 40, height: 40, borderRadius: '50%', background: COLORS[idx % COLORS.length], display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: '#060812', fontSize: 15 }}>{it.name.charAt(0)}</span>
                <div><div style={{ fontSize: 14, fontWeight: 600 }}>{it.name}</div><div style={{ fontSize: 12.5, color: 'var(--color-neutral-500)' }}>{it.role}</div></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
